import { Col, Row, Skeleton, Space } from "antd";

export default function SearchSkeletonComponent() {
  return (
    <div>
      <Col span={24}>
        <Row className="items-center">
          <Skeleton.Avatar active size={"large"} shape={"circle"} style={{ backgroundColor: "#222", width: "50px", height: "50px" }} />
          <Space direction="vertical" className="recentVisitedTextWrapper">
            <Skeleton.Input active size={"small"} style={{ backgroundColor: "#222 " }} />
          </Space>
        </Row>
      </Col>
      <br />
      <Col span={24}>
        <Row className="items-center">
          <Skeleton.Avatar active size={"large"} shape={"circle"} style={{ backgroundColor: "#222", width: "50px", height: "50px" }} />
          <Space direction="vertical" className="recentVisitedTextWrapper">
            <Skeleton.Input active size={"small"} style={{ backgroundColor: "#222 " }} />
          </Space>
        </Row>
      </Col>
    </div>
  );
}